import { initReactI18next } from 'react-i18next';
import XHR from 'i18next-xhr-backend';
import i18n from 'i18next';
// TODO: Check if it's still needed. Was used in previous config: config/i18n.js
import intervalPlural from 'i18next-intervalplural-postprocessor';
import format from './formatters';

const REFERENCE_LANGUAGE = 'en';

class ConfigBuilder {
  constructor() {
    this.i18n = i18n.use(initReactI18next).use(intervalPlural);
    this.config = {
      fallbackLng: REFERENCE_LANGUAGE,
      debug: false,
      lng: REFERENCE_LANGUAGE,
      saveMissing: false,
      ns: ['components'],
      interpolation: {
        escapeValue: false,
        format: format(this.i18n),
      },
      backend: null,
      editor: {},
      react: {
        useSuspense: false,
        hashTransKey: () => false,
        defaultTransParent: 'div',
      },
    };
  }

  /**
   * Use to override default value for storybook
   *
   * @param {string} lang translation code like en-US
   * @returns {ConfigBuilder}
   */
  withLanguage(lang) {
    this.config.lng = lang;
    this.config.fallbackLng = lang;

    return this;
  }

  /**
   * First param is used as default namespace, rest of parameters are used as additional namespaces.
   *
   * Default namespace let's you omit its namespace from hoc and translation key.
   *
   * Example:
   *
   * import { withTranslation } from '@piwikpro/ui-components';
   * class Component {...}
   * export withTranslation()(Component);
   *
   * @param {string} defaultNamespace It's used if no namespace is passed to translation hoc.
   * @param {...string} namespaces Additional namespaces used by application.
   * @returns {ConfigBuilder}
   */
  withNamespaces(defaultNamespace, ...namespaces) {
    this.config.defaultNS = defaultNamespace;
    this.config.ns = [defaultNamespace, ...this.config.ns, ...namespaces];

    return this;
  }

  /**
   * Useful in tests when you want to avoid unnecessary API calls
   *
   * @param {Array} resources
   */
  withResources(resources = {}) {
    this.config.resources = resources;
  }

  /**
   * Initializes configuration using selected options.
   *
   * @param {string} publicUrl Base URL from where translation files are served.
   * @returns {Promise} Promise that resolves to a t function on success.
   */
  build(publicUrl, version = '211d81e6', fileTemplate = '{{lng}}/{{ns}}.json') {
    if (!this.config.backend && !this.config.resources) {
      this.config.backend = {
        loadPath: `${publicUrl}/${fileTemplate}`,
        queryStringParams: { v: version },
      };
      this.i18n.use(XHR);
    }

    return this.i18n.init(this.config);
  }
}

export { ConfigBuilder };
